import { format, parseISO } from "date-fns";
import { formatInTimeZone } from "date-fns-tz";

export const getDateFormat = (dateAndTime: string) => {
  if (dateAndTime)
    return format(new Date(dateAndTime), "MM/dd/yyyy")
};

export const getDateTimeFormat = (dateAndTime: string) => {
  if (dateAndTime && dateAndTime.length > 0) {
    if (dateAndTime.includes(" "))
      return dateAndTime
    else
      return formatInTimeZone(parseISO(dateAndTime), "America/New_York", "MM/dd/yyyy hh:mm a")
  }
};
